import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FileObject, mapMediaToFileObject } from 'src/app/core/interfaces';
import { ImageDialogComponent } from '../image-dialog/image-dialog.component';
import { BaseComponent } from './../../../core/components/base/base.component';
import { FeedbackService } from './../../../core/services/feedback.service';
import { FileDownloadService } from './../../../core/services/file-download.service';

@Component({
  selector: 'app-file-gallery',
  templateUrl: './file-gallery.component.html',
  styleUrls: ['./file-gallery.component.scss']
})
export class FileGalleryComponent extends BaseComponent implements OnChanges {
  @Input() fileObjects: FileObject[] = [];
  @Input() deleteEnabled: boolean = true;
  @Input() ignoreSorting: boolean = false;
  @Input() enableEditing: boolean = false;
  @Output() fileRemove = new EventEmitter<number>();
  @Output() transformedFiles = new EventEmitter<FileObject[]>();
  @Input() maxPages: number | null = null;

  constructor(md: MatDialog, fs: FeedbackService, private fileDownloadService: FileDownloadService) {
    super(fs, md);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['fileObjects']) {
      const mediaData = changes['fileObjects'].currentValue as any;
      if (mediaData && mediaData.length && mediaData[0].mediaUrl) {
        this.fileObjects = mapMediaToFileObject(mediaData, this.ignoreSorting);
      }
    }
  }

  get toRender() {
    return this.maxPages != null
      ? this.fileObjects.slice(0, this.maxPages)
      : this.fileObjects;
  }

  isImage(fileObject: FileObject): boolean {
    return fileObject.type.startsWith('image');
  }

  isPdf(fileObject: FileObject): boolean {
    return fileObject.type === 'application/pdf';
  }

  maximizeFile(event: MouseEvent, fileObject: FileObject) {
    event.preventDefault();
    event.stopPropagation();
    if (this.isImage(fileObject)) {
      this.openImageDialog(fileObject);
    } else if (this.isPdf(fileObject) && !fileObject.uploaded) {
      this.openPdf(fileObject.url);
    }
  }

  async removeFile(event: MouseEvent, index: number) {
    event.preventDefault();
    event.stopPropagation();
    if (await this.showConfirmationDialog()) {
      this.fileRemove.emit(index);
    }
  }

  openImageDialog(fileObject: FileObject) {
    const ref = this.dialog.open(ImageDialogComponent, {
      data: {
        fileObjects: this.fileObjects.filter(obj => this.isImage(obj)),
        selectedFile: fileObject,
        enableEditing: this.enableEditing
      },
      panelClass: 'image-modal-panel'
    });

    const sub = ref.afterClosed()
      .subscribe(result => {
        this.fileObjects = result.fileObjects;
        this.transformedFiles.emit(this.fileObjects);
        sub.unsubscribe();
      })
  }

  openPdf(pdfUrl: string) {
    if (!pdfUrl) return; // nothing to open (e.g. a referral file whose PDF has no page images yet)
    window.open(pdfUrl, '_blank');
  }

  async downloadOriginalPdf(pdfUrl: string) {
    await this.fileDownloadService.downloadFromUrl(pdfUrl, 'original.pdf');
  }
}
